import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined"
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'

const makeUri = (path: string) => `${document.location.origin}/${path.replace(/^\//g, '')}`

export const UrlLinkInput = (props: any) => {
  const copy = () => {
    navigator.clipboard.writeText(`${makeUri(`/forms/${props.formKey}`)}`)
  }

  const open = () => {
    window.open(`${makeUri(`/forms/${props.formKey}`)}`)
  }

  return (
    <Box sx={{ "& button": { m: .5 } }}>
      <div>
        <Button
          variant="outlined"
          size="large"
          style={{ background: "#efefef", padding: "5px", paddingLeft: "10px" }}
        >
          <div style={{
            margin: 10,
            whiteSpace: 'nowrap',
            display: 'block',
            textOverflow: 'hidden',
            maxWidth: '30vw',
            overflowX: 'scroll'
          }}>
            {props.urlLink}
          </div>
          <Button
            endIcon={<ArrowOutwardOutlinedIcon />}
            variant="outlined"
            size="small"
            style={{ marginLeft: 20, background: "white" }}
            onClick={open}
          >
            Open
          </Button>
          <Button
            onClick={copy}
            endIcon={<ContentCopyOutlinedIcon />}
            variant="outlined"
            size="small"
            style={{ background: "white" }}
          >
            Copy
          </Button>
        </Button>
      </div>
    </Box>
  )
}